import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { PIXI } from '@colonist/pixi';
export class UICanvasConfig {
    static setCanvasConfigVariables(app) {
        this.appWidth = app.view.width / app.renderer.resolution;
        this.appHeight = app.view.height / app.renderer.resolution;
        const isPhone = PIXI.utils.isMobile.phone;
        const itemSizePhone = UIUtilsEjsVariables.shouldDisplayNewMobileGameUI ? Math.max(48, this.appHeight / 16) : this.appHeight / 8;
        const itemSizeDefault = this.appHeight / 10;
        this.itemSize = isPhone ? itemSizePhone : itemSizeDefault;
        const marginPhone = this.itemSize / 30;
        const marginDefault = this.itemSize / 40;
        this.margin = isPhone ? marginPhone : marginDefault;
    }
}
